import React, { useState, useEffect } from "react";
import { Form, FormGroup, Row, Col, ListGroup, ListGroupItem, Spinner, Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import style from "../../Grid.module.scss";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalFiscalResidence from "../../Modal/ModalFiscalResidence";
import { CircularProgress } from "../../../..";
import { AccountMode } from "../../../../utils/Helper";
import Groups from "../../../Asset/Tabs/Groups/Groups";

function generateEmptyFiscalResidence() {
  return {
    PersonFiscalResidenceCountryId: "",
    PersonFiscalResidenceCountryIso: "",
    PersonFiscalResidenceCountryName: "",
    PersonFiscalResidenceTin: "",
    PersonFiscalResidenceTaxId: undefined,
    PersonFiscalResidenceTaxIdName: "",
    PersonFiscalResidenceDateFrom: undefined,
    PersonFiscalResidenceDateTo: undefined,
    PersonFiscalResidenceId: 0,
    PersonFiscalResidenceIsActive: false,
  };
}

const FiscalResidencesTab = ({
  fiscalresidences,
  services,
  userType,
  onboarding,
  mode,
  document,
  person,
  setPersonData,
  userSession
}) => {
  const [modalFiscalResidence, setModalFiscalResidence] = useState({
    open: false,
    loading: false,
    initial: generateEmptyFiscalResidence(),
    error: undefined,
  });
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false,
  });

  const SaveNewFiscalResidence = (newFiscalResidence) => {
    const body = {
      person: {
        PersonId: person.PersonId,
        PersonFiscalResidence: [newFiscalResidence],
      },
    };
    setModalFiscalResidence((m) => ({
      ...m,
      open: true,
      loading: true,
    }));
    if (onboarding) {
      let docs = person.PersonFiscalResidence;
      let id = Number(docs.length) + 2;
      if (newFiscalResidence.PersonFiscalResidenceId > 0) {
        id = newFiscalResidence.PersonFiscalResidenceId;
        docs.forEach((p, i) => {
          if (p.PersonFiscalResidenceId == newFiscalResidence.PersonFiscalResidenceId) {
            docs.splice(i, 1);
          }
        });
      }
      const nResidence = {
        ...newFiscalResidence,
        PersonFiscalResidenceId: id,
      };

      docs.push(nResidence);
      const postPerson = {
        ...person,
        PersonFiscalResidence: docs,
      };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalFiscalResidence({
            ...modalFiscalResidence,
            open: false,
            callback: undefined,
            loading: false,
            messageShow: true,
            message: "",
          });
        } else {
          alert("Server Error");
        }
      });
    } else {
      const updatedBody = {
        ...body, 
        person: {
          ...body.person, 
          isOnboardingPerson: person.isOnboardingPerson,
        },
      };
      services.fetchUpdatePersonFiscalResidences(updatedBody, (response) => {
        if (response && response.result) {
          const { result } = response;
          if (response.result.Code === 200) {
            const newPerson = { ...person };
            let found = false;
            newPerson.PersonFiscalResidence = fiscalresidences.map((d) => {
              if (
                parseInt(d.PersonFiscalResidenceId, 10) ===
                parseInt(newFiscalResidence.PersonFiscalResidenceId, 10)
              ) {
                found = true;
                return {
                  ...newFiscalResidence,
                };
              }
              return {
                ...d,
              };
            });
            if (!found) {
              newFiscalResidence.PersonFiscalResidenceId = response.Id;
              newPerson.PersonFiscalResidence.push({ ...newFiscalResidence });
            }

            setPersonData({
              ...newPerson,
            });
            setModalFiscalResidence((m) => ({
              open: false,
              loading: false,
              initial: generateEmptyFiscalResidence(),
              error: undefined,
            }));
          }
        } else {
          setModalFiscalResidence((m) => ({
            ...m,
            open: true,
            loading: false,
          }));
        }
      });
    }
  };

  const handleDeleteFile = (newFiscalResidence) => {
    const body = {
      person: {
        PersonId: person.PersonId,
        PersonFiscalResidence: [newFiscalResidence],
      },
      delete: true,
    };
    if (onboarding) {
      let docs = person.PersonFiscalResidence;
      if (newFiscalResidence.PersonFiscalResidenceId > 0) {
        docs.forEach((p, i) => {
          if (p.PersonFiscalResidenceId == newFiscalResidence.PersonFiscalResidenceId) {
            docs.splice(i, 1);
          }
        });
      }
      const postPerson = {
        ...person,
        PersonFiscalResidence: docs,
      };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false,
          });
          setModalFiscalResidence({
            ...modalFiscalResidence,
            loading: false,
            messageShow: false,
            initial: undefined,
          });
        } else {
          alert("Server Error");
        }
      });
    } else {
      const updatedBody = {
        ...body, 
        person: {
          ...body.person, 
          isOnboardingPerson: person.isOnboardingPerson,
        },
      };
      services.fetchUpdatePersonFiscalResidences(updatedBody, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newPerson = { ...person };
          newPerson.PersonFiscalResidence.forEach((p, i) => {
            if (p.PersonFiscalResidenceId == newFiscalResidence.PersonFiscalResidenceId) {
              newPerson.PersonFiscalResidence.splice(i, 1);
            }
          });
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false,
          });
          setPersonData({
            ...newPerson,
          });
        }
      });
    }
  };

  const toggleModalConfirm = (d) =>
    setModalConfirm((mod) => {
      const newM = {
        ...mod,
        open: !mod.open,
      };
      if (d) {
        newM.title = "Are you sure you want to remove the selected Fiscal Residence?";
        newM.callback = () => handleDeleteFile(d);
      }
      return newM;
    });

  const toggleModalNewFiscalResidence = (initial) =>
    setModalFiscalResidence((m) => ({
      open: !m.open,
      loading: m.loading,
      initial: initial,
    }));

  if (!fiscalresidences) {
    return <Spinner />;
  }

  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {fiscalresidences.map((d) => (
              <ListGroupItem key={d.PersonFiscalResidenceId}>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Country: </Col>
                  <Col>{d.PersonFiscalResidenceCountryName}</Col>
                  <Col>
                  {userSession.IsReadOnly === false && <div
                      style={{ cursor: "pointer", float: "right" }}
                      onClick={() => toggleModalNewFiscalResidence(d)}
                    >
                      <i className="fa fa-edit" />
                    </div>}
                  </Col>
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Date From: </Col>
                  <Col>{new Date(d.PersonFiscalResidenceDateFrom).toLocaleDateString("es")}</Col>
                  <Col>
                    {userSession.IsReadOnly === false && <div style={{ cursor: "pointer", float: "right" }} onClick={() => toggleModalConfirm(d)}>
                      <i className="fa fa-trash" />
                    </div>}
                  </Col>
                </Row>

                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Date To: </Col>
                  <Col>
                    {" "}
                    {d.PersonFiscalResidenceIsActive
                      ? "Active"
                      : new Date(d.PersonFiscalResidenceDateTo).toLocaleDateString("es")}
                  </Col>
                  <Col />
                </Row>

                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Tax Id: </Col>
                  <Col>{d.PersonFiscalResidenceTin}</Col>
                  <Col />
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Tax Type: </Col>
                  <Col>{d.PersonFiscalResidenceTaxIdName}</Col>
                  <Col />
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Address: </Col>
                  <Col>{d.PersonFiscalResidenceAddress}</Col>
                  <Col />
                </Row>
              </ListGroupItem>
            ))}
          </ListGroup>
        </FormGroup>
      </Form>
      <ModalConfirm {...modalConfirm} toggle={toggleModalConfirm} />
      <ModalFiscalResidence
        {...modalFiscalResidence}
        toggle={toggleModalNewFiscalResidence}
        onSave={SaveNewFiscalResidence}
        document={document}
        services={services}
      />
      {userSession.IsReadOnly === false && <Button onClick={() => toggleModalNewFiscalResidence()} color="primary" style={{ marginRight: 10 }}>
        Add New Fiscal Residence
      </Button>}
    </div>
  );
};

FiscalResidencesTab.propTypes = {
  fiscalresidences: PropTypes.array.isRequired,
  services: PropTypes.object.isRequired,
};

FiscalResidencesTab.defaultProps = {
  fiscalresidences: undefined,
};

function RenderDropdownActions({ onEdit, onDelete, index }) {
  return (
    <UncontrolledDropdown>
      <DropdownToggle color="link" size="lg" className={style.dropdown}>
        <i className="icon-options-vertical icons d-block" />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onEdit(index)}>
          <i className="fa fa-edit" />
          Edit
        </DropdownItem>
        <DropdownItem onClick={() => onDelete(index)}>
          <i className="fa fa-trash" />
          Delete
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

RenderDropdownActions.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default FiscalResidencesTab;

